<template>
	<div>
		<!-- banner -->
		<banner></banner>
		<!-- banner end -->

		<!-- 切换导航 -->
		<switch-nav @onClick="handleNavClick" :index="index" :fixed="fixed"></switch-nav>
		<!-- 切换导航 end -->

		<!-- 工具下载 -->
		<tools-download :index="index"></tools-download>
		<!-- 工具下载 end -->
	</div>
</template>

<script>
	import Banner from './components/banner.vue';
	import SwitchNav from './components/switch_nav.vue';
	import ToolsDownload from './components/tools_download.vue';

	export default {
		mounted() {
			/**
			 * 400:banner高度
			 * 100:上外边距
			 * 20:预留值
			 * 544:每个item自身高度
			 * */
			this.offsetTops = [400 + 100 - 20, 400 + 100 + 544 + 100 - 20, 400 + 100 + 544 + 100 + 544 + 100 - 20, 400 +
				100 + 544 + 100 + 544 + 100 + 544 + 100 - 20
			];
			this.listenWindowScroll();
		},
		beforeDestroy() {
			this.removeListenWindowScroll();
		},
		data() {
			return {
				index: 0,
				fixed: false
			}
		},
		methods: {
			/*************** @Events ******************/
			// 点击左侧导航
			handleNavClick(index) {

				this.index = index;
				let ele = document.documentElement || document.body;
				console.log(this.index)
				ele.scrollTop = this.offsetTops[index];
			},

			/*************** @Function ******************/
			// 监听页面滚动
			listenWindowScroll() {
				window.addEventListener('scroll', this.windowScroll, false);
			},
			// 移除页面滚动监听
			removeListenWindowScroll() {
				window.removeEventListener('scroll', this.windowScroll, false);
			},
			windowScroll() {
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				scrollTop >= this.offsetTops[0] ? (this.fixed = true) : (this.fixed = false);
				if (scrollTop < this.offsetTops[1]) {
					this.index = 0;
				} else if (scrollTop < this.offsetTops[2]) {
					this.index = 1;
				} else if (scrollTop < this.offsetTops[3]) {
					this.index = 2;
				} else {
					this.index = 3;
				}
			}
		},
		components: {
			Banner,
			SwitchNav,
			ToolsDownload
		}
	}
</script>

<style scoped>
</style>